export default "__VITE_ASSET__BXT_u5nx__"